import { SET_UPGRADE_LINK } from 'constants/FlagConstants';

export function setShouldDisplayUpgradeLink(displayLink) {
  return (dispatch) => {
    dispatch({ type: SET_UPGRADE_LINK, payload: { displayUpgradeLink: displayLink } });
  };
}
